export default __webpack_public_path__ + "static/media/chantilly7.04e4bc42.jpg";